import React from 'react'
import { graphql } from 'gatsby'
import { Container, Col, Row } from 'reactstrap'

import SiteDocumentations from '../../../components/SiteDocumentations'

import SEO from '../../../components/seo'

import Irriglobe from './irriglobe.png'

class irriglobe extends React.Component {
  render() {
    const seoData = {
      title: "Manuels d’instruction d'irrigation Irriglobe",
      description: "Consultez notre documentation des produits d'irrigation Irriglobe",
      coverImage: Irriglobe,
      path: this.props.location.pathname,
      schemaOrg: ''
    }

    return (
      <div>
        <SEO seoData={seoData} />
        <Container>
          <Row style={{alignItems: "center", marginBottom: 10}}>
            <Col lg={2} md={2} xs={6}>
              <img src={Irriglobe} alt="Irriglobe"/>
            </Col>
            <Col lg={10} md={10} xs={12}><h1>Manuels d’instruction Irriglobe</h1></Col>
          </Row>
          <SiteDocumentations {...this.props} />
        </Container>
      </div>
    )
  }
}

export default irriglobe

export const irriglobeDocumentationQuery = graphql`
  query IrriglobeDocumentation {
    site {
      meta: siteMetadata {
        title
        description
        url: siteUrl
        author
      }
    }
    remark: allMarkdownRemark(
      filter: { frontmatter: { vendor: { eq: "Irriglobe" } } }
    ) {
      documentations: edges {
        documentation: node {
          id
          html
          frontmatter {
            layout
            title
            path
            coverImage {
              childImageSharp {
                fluid(maxWidth: 400) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
    }
  }
`
